import { useHref } from 'react-router';
import { RoutePaths } from 'shared/routes.js';

/**
 * Resolves the Terms of service URL against the router basename.
 */
export const useTermsHref = () => useHref(RoutePaths.TERMS);
